import { render, staticRenderFns } from "./uploadAvatar.vue?vue&type=template&id=9b6a9246&scoped=true&"
import script from "./uploadAvatar.vue?vue&type=script&lang=js&"
export * from "./uploadAvatar.vue?vue&type=script&lang=js&"
import style0 from "./uploadAvatar.vue?vue&type=style&index=0&id=9b6a9246&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6a9246",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Input: require('/data/jenkins-data/workspace/Unicew-mobile-pro/pagePC/components/Design/Input.vue').default,CommonDialog: require('/data/jenkins-data/workspace/Unicew-mobile-pro/pagePC/components/CommonDialog.vue').default})
